import CommonSettings from './CommonSettings'

export default function VideoSettings({ block, onUpdate }) {
  const { settings } = block

  const getWidthPercent = () => {
    const w = settings.width || '100%'
    if (w.includes('%')) return parseInt(w) || 100
    return 100
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
      <h4 style={{ margin: 0, fontSize: '0.9rem', fontWeight: '600' }}>Video Settings</h4>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Video URL
        </label>
        <input
          type="text"
          value={settings.videoUrl || ''}
          onChange={(e) => onUpdate({ videoUrl: e.target.value })}
          placeholder="https://www.youtube.com/watch?v=..."
          style={{ width: '100%', fontSize: '0.85rem', padding: '0.5rem' }}
        />
        <span style={{ fontSize: '0.7rem', color: '#94a3b8', display: 'block', marginTop: '0.25rem' }}>
          Supports YouTube URLs. The video opens in a new tab when clicked.
        </span>
      </div>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Custom Thumbnail URL (optional)
        </label>
        <input
          type="text"
          value={settings.thumbnailUrl || ''}
          onChange={(e) => onUpdate({ thumbnailUrl: e.target.value })}
          placeholder="Auto-generated from YouTube URL"
          style={{ width: '100%', fontSize: '0.85rem', padding: '0.5rem' }}
        />
        <span style={{ fontSize: '0.7rem', color: '#94a3b8', display: 'block', marginTop: '0.25rem' }}>
          Leave empty to auto-fetch from YouTube
        </span>
      </div>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Alt Text
        </label>
        <input
          type="text"
          value={settings.altText || ''}
          onChange={(e) => onUpdate({ altText: e.target.value })}
          placeholder="Video description"
          style={{ width: '100%', fontSize: '0.85rem', padding: '0.5rem' }}
        />
      </div>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Width: {settings.width || '100%'}
        </label>
        <input
          type="range"
          min="30"
          max="100"
          step="5"
          value={getWidthPercent()}
          onChange={(e) => onUpdate({ width: `${e.target.value}%` })}
          style={{ width: '100%', cursor: 'pointer' }}
        />
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '0.7rem', color: '#94a3b8', marginTop: '0.25rem' }}>
          <span>30%</span>
          <span>65%</span>
          <span>100%</span>
        </div>
      </div>

      <div>
        <label style={{ fontSize: '0.85rem', fontWeight: '500', display: 'block', marginBottom: '0.5rem' }}>
          Alignment
        </label>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          {['left', 'center', 'right'].map(align => (
            <button
              key={align}
              onClick={() => onUpdate({ textAlign: align })}
              style={{
                flex: 1,
                padding: '0.5rem',
                border: settings.textAlign === align ? '2px solid var(--color-primary)' : '1px solid #e5e7eb',
                borderRadius: '6px',
                background: settings.textAlign === align ? 'rgba(99, 102, 241, 0.08)' : '#fff',
                color: settings.textAlign === align ? 'var(--color-primary)' : '#64748b',
                fontWeight: settings.textAlign === align ? '600' : '400',
                fontSize: '0.8rem',
                cursor: 'pointer',
                textTransform: 'capitalize'
              }}
            >
              {align}
            </button>
          ))}
        </div>
      </div>

      <CommonSettings settings={settings} onUpdate={onUpdate} />
    </div>
  )
}
